import axios from "axios";
import { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { server } from "../../server";
import { getDecodedToken } from "../../auth";
import { useLocation } from "react-router-dom";

function AssignViewIncidents() {
  const { state } = useLocation();
  const [admissionNo, setAdmissionNo] = useState(
    () => state?.admissionNo || ""
  );
  const [studentData, setStudentData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [incident, setIncident] = useState([]);
  const [selectedIncident, setSelectedIncident] = useState("");

  const [user, setUser] = useState(null);

  useEffect(() => {
    const decodedData = getDecodedToken();
    if (decodedData) {
      setUser(decodedData);
    }
  }, []);

  const handleSearch = async (e) => {
    if (e && e.preventDefault) e.preventDefault();

    if (!admissionNo) {
      toast.error("Enter Admission No", { position: "top-right" });
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const studentResponse = await axios.post(
        `${server}/getParticularStudentMongodb`,
        { admission_no: admissionNo },
        {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      const studentData = studentResponse.data?.["body-json"]?.body?.student;

      if (studentData) {
        setStudentData(studentData);
      } else {
        toast.error("Wrong Admission No", { position: "top-right" });
        setStudentData(null);
      }
    } catch (err) {
      console.error("Search Error:", err);
      setError("Error fetching data.");
      setStudentData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (admissionNo.length === 5) {
      handleSearch();
    }
  }, [admissionNo]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedIncident) {
      toast.error("Select Incident", { position: "top-right" });
      return;
    }

    setLoading(true);

    const incidentData = incident.find((inc) => inc._id === selectedIncident);

    const newIncident = {
      title: incidentData?.title,
      incidentId: incidentData?.incidentId,
      points: incidentData?.points,
      assignedBy: user?.userId,
      date: new Date().toISOString().split("T")[0],
    };

    const payload = {
      admission_no: admissionNo,
      behaviourRecords: [newIncident],
    };

    try {
      await axios.post(`${server}/create_behaviour_records_mongodb`, payload);

      setStudentData((prevData) => ({
        ...prevData,
        behaviourRecords: [...(prevData.behaviourRecords || []), newIncident],
      }));

      toast.success("Incident Added", { position: "top-right" });
      setAdmissionNo("");
      setStudentData(null);
    } catch (error) {
      toast.error("Please Try Again", { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };

  const fetchIncident = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${server}/alldata_of_incident_mongodb`,
        {
          headers: { Authorization: `${localStorage.getItem("token")}` },
        }
      );
      const responseData = response.data?.["body-json"]?.body?.data;
      if (Array.isArray(responseData)) {
        setIncident(responseData);
      } else {
        console.error("Unexpected API Response Format:", response.data);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIncident();
  }, []);

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div className="">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-12">
                  <div class="m-3 mt-2 pt-1 d-flex justify-content-between">
                    <div class="d-flex align-items-center mt-2">
                      <span
                        onClick={() => window.history.back()}
                        class="back-button me-3 cursor-pointer"
                      >
                        <i className="bi bi-arrow-left fs-3"></i>
                      </span>
                      <nav aria-label="breadcrumb">
                        <h4 className="m-0 lh-sm">Assign / View Incidents</h4>
                        <ol class="breadcrumb pe-3 lh-sm">
                          <li class="breadcrumb-item">
                            <a href="#">Behaviour Records</a>
                          </li>
                          <li
                            class="breadcrumb-item active"
                            aria-current="page"
                          >
                            Assign / View Incidents
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {!studentData && (
            <section className="mx-3 bg-light">
              <div className="container-fluid">
                <div className="col-lg-5 col-md-8 col-12">
                  <div className="row align-items-center justify-content-center bg-white p-4 rounded-4">
                    <div className="d-flex flex-column">
                      <div className="d-flex flex-column gap-1">
                        <h1 className="fw-medium mb-0 fs-4 lh-1">
                          Enter Admission No.
                          <br />
                          <span className="mb-0 text-secondary fw-normal fs-5">
                            Admission No. to retrieve the student's academic &
                            incident details.
                          </span>
                        </h1>
                      </div>
                      <div className="col-7 mt-3">
                        <form
                          className="d-flex align-items-center"
                          onSubmit={handleSearch}
                        >
                          <span className="position-absolute ps-4">
                            <i className="bi bi-person fs-4" />
                          </span>
                          <input
                            type="search"
                            value={admissionNo}
                            autoFocus
                            onChange={(e) => setAdmissionNo(e.target.value)}
                            className="form-control ps-7 fs-5 lg-search-box"
                            maxLength={5}
                            placeholder="Enter Admission No"
                          />
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}

          {studentData && (
            <div className="mt-1">
              <div class="container-fluid">
                <div className="row g-2">
                  <div className="col-lg-8">
                    <div>
                      <div class="px-5 py-3 bg-white rounded-4">
                        <div
                          class="accordion accordion-flush"
                          id="accordionExample"
                        >
                          <div id="headingOne">
                            <h3 class="m-0 fs-list">
                              <a
                                href="#"
                                class="d-flex align-items-center text-inherit"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-controls="collapseOne"
                              >
                                <span class="me-auto fs-5">
                                  1. Assign Incident{" "}
                                  <span className="ms-3 text-secondary"></span>
                                </span>
                                <div className="d-flex align-items-center">
                                  <span class="badge bg-success-soft me-3 px-3">
                                    Editable
                                  </span>
                                  <div class="form-check form-switch me-4">
                                    <input
                                      type="checkbox"
                                      class="form-check-input m-0"
                                      checked
                                    />
                                  </div>
                                  <span className="collapse-toggle">
                                    <i class="bi bi-chevron-down"></i>
                                  </span>
                                </div>
                              </a>
                            </h3>

                            <div
                              id="collapseOne"
                              class="collapse"
                              aria-labelledby="headingOne"
                              data-bs-parent="#accordionExample"
                            >
                              <form id="issueForm" onSubmit={handleSubmit}>
                                <div className="row g-2 mt-2 mb-3">
                                  <div className="col-lg-6 col-12">
                                    <label className="form-label mb-1 ms-3">
                                      Incident{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                      options={incident.map((incidentItem) => ({
                                        value: incidentItem._id,
                                        label: incidentItem.title,
                                      }))}
                                      name="incident"
                                      placeholder="..."
                                      onChange={(selectedOption) =>
                                        setSelectedIncident(
                                          selectedOption?.value
                                        )
                                      }
                                      value={
                                        incident.find(
                                          (item) =>
                                            item._id === selectedIncident
                                        )
                                          ? {
                                              value: selectedIncident,
                                              label: incident.find(
                                                (item) =>
                                                  item._id === selectedIncident
                                              ).title,
                                            }
                                          : null
                                      }
                                    />
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="px-5 py-3 mt-1 bg-white rounded-4">
                        <div
                          class="accordion accordion-flush"
                          id="accordionExample"
                        >
                          <div id="headingTwo">
                            <h3 class="m-0 fs-list">
                              <a
                                href="#"
                                class="d-flex align-items-center text-inherit"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseTwo"
                                aria-controls="collapseTwo"
                              >
                                <span class="me-auto fs-5">
                                  2. Behaviour Records{" "}
                                  <span className="ms-3 text-secondary"></span>
                                </span>
                                <div className="d-flex align-items-center">
                                  <span class="badge bg-secondary-soft me-6 px-3">
                                    Locked
                                  </span>
                                  <span className="collapse-toggle">
                                    <i class="bi bi-chevron-down"></i>
                                  </span>
                                </div>
                              </a>
                            </h3>

                            <div
                              id="collapseTwo"
                              class="collapse"
                              aria-labelledby="headingTwo"
                              data-bs-parent="#accordionExample"
                            >
                              <div className="mt-3 pt-1">
                                {studentData &&
                                studentData.behaviourRecords &&
                                studentData.behaviourRecords.length > 0 ? (
                                  <div class="table-responsive border-0 overflow-y-hidden bg-white rounded-4">
                                    <table className="table mb-0 text-nowrap table-centered">
                                      <thead className="bg-light rounded-4">
                                        <tr>
                                          <th className="text-dark">No.</th>
                                          <th className="lh-1 text-dark">
                                            Details
                                            <i className="bi bi-info-circle ms-2 text-dark"></i>
                                            <br />
                                            <span className="fs-8 fw-normal text-secondary">
                                              Displaying Information as per
                                              Record
                                            </span>
                                          </th>
                                          <th className="lh-1 text-dark">
                                            Action
                                            <i className="bi bi-person-gear ms-2 text-dark"></i>
                                            <br />
                                            <span className="fs-8 fw-normal text-secondary">
                                              Role-Specific Action Panel
                                            </span>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {studentData.behaviourRecords.map(
                                          (record, index) => (
                                            <tr key={index}>
                                              <td>{index + 1}.</td>
                                              <td className="lh-sm py-4 text-wrap">
                                                <span className="text-dark">
                                                  Title
                                                </span>{" "}
                                                &mdash; {record.title}
                                                <br />
                                                <span className="text-dark">
                                                  Points
                                                </span>{" "}
                                                &mdash; ({record.points})
                                                <br />
                                                <span className="text-dark">
                                                  Assigned By
                                                </span>{" "}
                                                &mdash; {record.assignedBy}
                                                <br />
                                                <span className="text-dark">
                                                  Date
                                                </span>{" "}
                                                &mdash; {record.date}
                                              </td>
                                              <td>
                                                <div className="d-flex flex-column gap-1 width-fit-content">
                                                  <span class="badge bg-danger-soft cursor-pointer px-4 rounded-3 btn-py-sm">
                                                    Delete
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                ) : (
                                  <div className="text-center">
                                    <img
                                      src="/assets/images/not-found.png"
                                      width="110"
                                      className="mb-2"
                                      alt="No records found"
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="my-3 d-flex float-end me-5">
                      <button
                        type="submit"
                        form="issueForm"
                        class="btn btn-success mt-2 px-6"
                      >
                        {loading ? (
                          <div
                            class="spinner-border spinner-border-sm"
                            role="status"
                          ></div>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div class="p-5 bg-white rounded-4 sticky-top top-10 z-1">
                      <div className="d-flex flex-column align-items-center">
                        <div>
                          <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative overflow-hidden me-2">
                            <img
                              src={
                                studentData?.studentDetails?.studentImage ||
                                `/assets/images/profile.png`
                              }
                              alt="Image"
                              width="150"
                              height="150"
                              className="object-fit-cover rounded-3"
                            />
                          </div>
                          <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative">
                            <img
                              src="https://cdn-icons-png.flaticon.com/512/14021/14021384.png"
                              className="w-100 position-absolute p-2 rounded-4"
                              alt="QR"
                            />
                          </div>
                        </div>

                        <div className="mt-3 text-center">
                          <h3 class="m-0 fs-4 lh-sm">
                            {studentData?.studentDetails?.name
                              .toLowerCase()
                              .replace(/\b\w/g, (char) =>
                                char.toUpperCase()
                              )}{" "}
                            ({studentData?.currentClass},{" "}
                            {studentData?.studentDetails?.currentSection})
                          </h3>
                          <p className="m-0">
                            {studentData?.studentDetails?.admission_no},{" "}
                            {new Date(
                              studentData?.studentDetails?.admissionDate
                            ).toLocaleDateString("en-GB")}
                          </p>

                          <p className="mt-1 mb-0 text-danger lh-sm">
                            (+91) {studentData?.parentDetails[0]?.phone}
                            <br />
                            <span className="text-lowercase">
                              {studentData?.parentDetails[0]?.email}
                            </span>
                          </p>
                          <p className="m-0 lh-sm mt-4 text-capitalize">
                            {studentData?.presentAddress?.address
                              .toLowerCase()
                              .replace(/\b\w/g, (char) => char.toUpperCase())}
                            <br />
                            {studentData?.presentAddress?.city} -{" "}
                            {studentData?.presentAddress?.state}
                          </p>
                          <p className="mt-3 mb-0 text-dark lh-sm">
                            Mr.{" "}
                            {studentData?.parentDetails[0]?.name
                              .toLowerCase()
                              .replace(/\b\w/g, (char) => char.toUpperCase())}
                            <br />
                            Mrs.{" "}
                            {studentData?.parentDetails[1]?.name
                              .toLowerCase()
                              .replace(/\b\w/g, (char) => char.toUpperCase())}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </main>
      </div>
    </>
  );
}

export default AssignViewIncidents;
